const protocol = require('@/api/protocol.js')

const domain = {}

/**
 * catalogDomainCreate() //
 * A promise that returns a catalog of domains
 * @return {promise} - List of audience
 */
domain.catalogDomainCreate = (e) => {
  return new Promise((resolve, reject) => {
    const path = '/websitesList'
    const method = 'get'
    const params = {}
    const data = getDataObject(e, params)
    protocol
      .call(path, method, data)
      .then(res => {
        return resolve(res)
      })
      .catch(err => {
        return reject(err)
      })
  })
}

// list

// detail

// create

// listUser

// detailUser

// createUser

// user

//
/**
 * list({ userId }) //
 * A promise that returns a list of domains.
 * @param(string) userId - A user ID
 * @return(promise) A list of domains
 */
domain.list = (e) => {
  return new Promise((resolve, reject) => {
    const path = '/domainList'
    const method = 'get'
    const params = {}
    const data = getDataObject(e, params)
    protocol
      .call(path, method, data)
      .then(res => {
        return resolve(res)
      })
      .catch(err => {
        return reject(err)
      })
  })
}

/**
 * domainList({ userId }) //
 * A promise that returns a list of domains.
 * @param(string) userId - A user ID
 * @return(promise) A list of domains
 */
domain.detail = (e) => {
  return new Promise((resolve, reject) => {
    if (e.userId === undefined) return false
    const path = '/domain/list/' + e.userId
    const method = 'get'
    const data = { }
    protocol
      .call(path, method, data)
      .then(res => {
        return resolve(res)
      })
      .catch(err => {
        return reject(err)
      })
  })
}
domain.create = (e) => {
  return new Promise((resolve, reject) => {
    const path = '/api/auth/login'
    const method = 'post'
    const data = {
      email: e.email,
      password: e.password
    }
    protocol
      .call(path, method, data)
      .then(res => {
        return resolve(res)
      })
      .catch(err => {
        return reject(err)
      })
  })
}

domain.domainAvailable = (name) => {
  return new Promise((resolve, reject) => {
    const path = '/domainAvailable'
    const method = 'get'
    const data = { name }
    protocol
      .call(path, method, data)
      .then(res => {
        return resolve(res)
      })
      .catch(err => {
        return reject(err)
      })
  })
}


function getDataObject (e, params) {
  const data = {}
  if (typeof e === 'object') {
    for (const [key, value] of Object.entries(e)) {
      data[key] = value
    }
    return data
  } else return {}
}
module.exports = domain
